import { Container, Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useDMEStore } from '../../store'
import useStyles from './styles'
import PhysicianSearchForm from '../../forms/PhysicianSearchForm'
import { UI } from '../../../global'
import CustomerInformationView from '../CustomerInformationView'
import { SEARCH_PHYSICIAN_PATH } from '../../constants'
import PhysicianResultView from '../PhysicianResultView'
import CheckoutJourneyStepsWidget from '../../widgets/CheckoutJourneyStepsWidget'
import CheckoutJourneyWrapperWidget from '../../widgets/CheckoutJourneyWrapperWidget'

const PhysicianSearchView: UI.ViewComponent<UI.LifeCycle> = observer(
  ({ router, onComponentDidMount }) => {
    const store = useDMEStore()
    const classes = useStyles()

    const navigateToResults = () => {
      PhysicianResultView.location!(router)
    }

    if (!store.user.present) {
      CustomerInformationView.location!(router)
      return null
    }

    useEffect(() => {
      onComponentDidMount()
    }, [])

    return (
      <Container className={classes.viewContainer}>
        <CheckoutJourneyWrapperWidget>
          <CheckoutJourneyStepsWidget
            currentPath={`/${SEARCH_PHYSICIAN_PATH.split('/').pop()}`}
          />
          <Typography
            gutterBottom
            className={classes.disclaimer}
            variant="body1"
          >
            To make it easier for you, we can send a prescription request
            directly to your pregnancy care provider.
          </Typography>
          <PhysicianSearchForm nextAction={navigateToResults} />
        </CheckoutJourneyWrapperWidget>
      </Container>
    )
  }
)

PhysicianSearchView.location = (router) => {
  if (router) {
    router.push(SEARCH_PHYSICIAN_PATH)
  } else {
    window.location.href = SEARCH_PHYSICIAN_PATH
  }
}

export default PhysicianSearchView
